/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";

import { fetchVehicleListAction } from "../../../../redux/action-creators/contractedActionCreator";
import TableWrapper from "../../../../shared/layout/table-components/tableWrapper";
import { templateStrings } from "../../../../Constant";
import { setContractStateData } from "../../../../redux/actions/contractedVehicleAction";

const updateSelected = (selectedWrapper, selected, setSelected) => {
  if (!selectedWrapper.length && selected.length) {
    setSelected(selectedWrapper);
  }
};

const getSelectedOperatorId = (value) => {
  if (!value.length) {
    return [];
  }
  return value;
};

function VehicleList(props) {
  const {
    contractType, searchString, handleVehicleSelection, selected: selectedWrapper,
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const content = useSelector(
    (state) => state.Contracts.contractList.items || [],
  );

  const cityFilter = useSelector((state) => state.Cities.selectedCity);

  const operatorFilter = useSelector(
    (state) => state.Operators.selectedOperator,
  );

  const totalItems = useSelector(
    (state) => state.Contracts.contractList.totalItems || 0,
  );

  const contractStateData = useSelector(
    (state) => state.Contracts.contractStateData || {},
  );

  const headerLoader = useSelector((state) => state?.loadingBar?.header);
  const templateString = templateStrings.contract;

  const [rowsPerPage, setRowsPerPage] = useState(contractStateData?.rowsPerPage || 10);
  const [pageNo, setPageNo] = useState(contractStateData?.pageNo || 0);
  const [sortBy, setSortBy] = useState({});
  const [selected, setSelected] = useState([]);

  const handleChange = useCallback(
    (input, value) => {
      switch (input) {
        case "pageNo":
          setPageNo(value);
          break;
        case "rowsPerPage":
          setRowsPerPage(value);
          break;
        case "selected":
          // eslint-disable-next-line no-case-declarations
          const selectedOperatorId = getSelectedOperatorId(value);
          setSelected(selectedOperatorId);
          break;
        default:
          break;
      }
    },
    [selected],
  );

  const onSortToggle = (value, key) => {
    setSortBy({ [key]: value });
  };

  const handleAction = useCallback((vehicleDetails) => {
    dispatch(setContractStateData({ rowsPerPage, pageNo, contractType }));
    history.push("/contract/vehicle", vehicleDetails);
  }, [contractType, rowsPerPage, pageNo]);

  useEffect(() => {
    updateSelected(selectedWrapper, selected, setSelected);
  }, [selectedWrapper]);

  useEffect(() => {
    setRowsPerPage(contractStateData?.rowsPerPage || 10);
    setPageNo(contractStateData?.pageNo || 0);
    dispatch(setContractStateData({ rowsPerPage: 10, pageNo: 0, contractType: "" }));
    if (Object.keys(sortBy).length > 0) setSortBy({});
  }, [contractType]);

  useEffect(() => {
    handleVehicleSelection(selected);
  }, [selected]);

  useEffect(() => {
    const payload = {
      pageNo,
      pageSize: rowsPerPage,
      searchString,
      sortBy,
      operatorFilter,
      cityFilter,
      contractType,
    };

    dispatch(fetchVehicleListAction(payload));
  }, [
    contractType,
    pageNo,
    rowsPerPage,
    searchString,
    sortBy,
    operatorFilter,
    cityFilter,
  ]);

  return (
    <TableWrapper
      content={!headerLoader && content}
      selected={selected}
      pageNo={pageNo}
      uniqueKey={contractType === "all" ? "_id" : "busNumber"}
      rowsPerPage={rowsPerPage}
      count={totalItems}
      handleChange={handleChange}
      templateString={templateString}
      selectionAllowed={contractType !== "all"}
      handleAction={handleAction}
      onSortToggle={onSortToggle}
      sortBy={sortBy}
    />
  );
}

export default VehicleList;
